import React, { useContext } from 'react';

import { faPencilAlt, faPortrait } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import style from './style.js';
import { useHistory } from 'react-router-dom';
import { DepartmentContext } from '../../../../../../DepartmentWrapper';

const EvaluatorDropDownItem = ({ evaluator, index, candidateInteviewCount, candidates, ignoreValidity }) => {
  const { UserPhotoUrl } = evaluator;
  const history = useHistory();
  const dContext = useContext(DepartmentContext);
  return (
    <div
      style={{
        ...style.itemRow,
        backgroundColor: index % 2 == 0 ? 'var(--rr-surface-stripe)' : null,
      }}
    >
      <div style={{ ...style.simpleColumn, width: '100% ' }}>
        <div style={{ ...style.spacedBetweenRow, alignItems: 'center' }}>
          <div style={{ ...style.simpleColumn, width: '100%' }}>
            <div style={{ ...style.simpleRow, alignItems: 'flex-start' }}>
              <div style={style.simpleColumn}>
                {UserPhotoUrl ? (
                  <img src={UserPhotoUrl} style={style.imgPlaceHolder} />
                ) : (
                  <FontAwesomeIcon style={style.imgPlaceHolder} icon={faPortrait} />
                )}
              </div>
              <div style={style.info}>
                <div style={{ ...style.simpleRow, fontWeight: 'bold', textAlign: 'left', alignItems: 'flex-start' }}>
                  {evaluator
                    ? `${evaluator.UserLast ? `${evaluator.UserLast}, ` : ''}${evaluator.UserFirst || ''}`
                    : ''}
                </div>
                {ignoreValidity ? null : (
                  <div style={{ ...style.simpleRow, fontSize: 11, textAlign: 'left' }}>
                    Candidates to interview: {candidateInteviewCount} / {Object.values(candidates).length}
                  </div>
                )}
              </div>
            </div>
          </div>

          {ignoreValidity ? null : (
            <div style={style.info}>
              <FontAwesomeIcon
                icon={faPencilAlt}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  const pathExploded = history.location.pathname.split('/');
                  const scheduleID = pathExploded[pathExploded.length - 1];
                  const pk_Department =
                    sessionStorage.getItem('department') ||
                    (dContext && dContext.department ? dContext.department.pk_Department : null);
                  const departmentQuery = pk_Department ? `&pk_Department=${pk_Department}` : '';

                  //NEW ONE!
                  window.open(
                    `/administrator/evaluate?pk_InterviewDate=${scheduleID}&pk_User=${evaluator.pk_User}${departmentQuery}`,
                    '_blank',
                    'noopener,noreferrer',
                  );
                  // OLD!
                  // window.open(`/evaluate?pk_User=${evaluator.pk_User}`, '_blank', 'noopener,noreferrer');
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EvaluatorDropDownItem;
